function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#9BADBC",
  fillRule: "evenodd",
  d: "M8.277 1.076l5.316 8.638A1.5 1.5 0 0112.316 12H1.684A1.5 1.5 0 01.407 9.714l5.316-8.638a1.5 1.5 0 012.554 0zM8 10a1 1 0 10-2 0 1 1 0 002 0zM6.34 3c-.186-.002-.338.116-.34.263v.014l.304 4.474c.012.141.16.25.34.249h.713c.178.001.327-.108.339-.25L8 3.278c.008-.147-.136-.27-.321-.277h-1.34z"
});

var SvgWarning = function SvgWarning(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12"
  }, props), _ref);
};

export default SvgWarning;